// src/views/ProcesosBatch/GenerarArchivoSap/GenerarArchivoSap.jsx
import React from "react";
import EjecutarProceso from "../../EstadosFlujos/Procesos/EjecutarProceso";

export default function GenerarArchivoSap() {
  return (
    <EjecutarProceso
      procesoId={9}
      titulo="Generar archivos SAP"
      showSuccess={true}   // 👈 muestra notify SUCCESS con el output del backend
    />
  );
}
